import type { BooleanFilterState } from '../../../../../common/constants/filters/boolean-filter/types';
import type { ProductKeys, ProductKeys3P } from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createBooleanFilter } from '../../../../filters/boolean-filter/create-boolean-filter';

const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('hasAttachment');

/**
 * `hasAttachment` is the user-facing filter — the AGG `teamsFilters.hasAttachment` field accepts a
 * boolean toggle indicating whether the message has an attachment. Internal naming uses
 * `hasAttachment` (URL key, folder, i18n) and the wire-level key remains `hasAttachment` per the
 * AGG schema contract.
 *
 * Scoped to MS Teams only. The available products list is derived from the 3P product configs via
 * `getProducts3PFromConfigForFilter('hasAttachment')`, so the filter automatically becomes
 * available for any 3P product whose config opts into the `hasAttachment` filter.
 */
export const filter: Readonly<{
	id: 'hasAttachment';
	type: 'boolean';
	queryParams: {
		key: string;
		getState: (
			queryParams: Record<string, string[]>,
			cloudId: string,
		) => BooleanFilterState<'hasAttachment'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (
		state: unknown,
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'hasAttachment'>;
	getInitialState: (
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'hasAttachment'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createBooleanFilter({
	id: 'hasAttachment',
	queryParams: { key: 'hasAttachment' },
	products: [...products3PFromConfig],
	alwaysVisible: true,
	universal: false,
});
